<template>
  <div>
    <top-bar :heading="'User Progression: ' + student.name_full" :buttons="buttons"></top-bar>
    <div class="container-fluid mt-3">
      <b-card header="Progressions">
        <progression-charts :courses="enabledCourseData"></progression-charts>
      </b-card>
      <b-card header="Submissions">
        <student-submissions :user_id="id" :user="student"></student-submissions>
      </b-card>
    </div>
  </div>
</template>

<script>
import TopBar from '../../components/TopBar';
import ProgressionCharts from '../../components/ProgressionCharts';
import StudentSubmissions from '../../components/Dashboard/StudentSubmissions';

export default {
  name: 'UserProgressions',
  components: {StudentSubmissions, ProgressionCharts, TopBar},
  data () {
    return {
      submissions: {
        loaded: false,
        data: {}
      },
      studentCourses: [],
      enabledCourseData: [],
      student: {
        id: this.id,
        loaded: false
      },
      buttons: [
        {label: 'Edit User', 'url': '/users/' + this.id},
        {label: 'Training Plan', 'url': '/users/' + this.id + '/training_plan', access: this.$auth.check(['rto', 'rto_trainer', 'admin', 'super_admin', 'super_admin'])},
        //{label: 'Progression', url: '/users/' + this.id + '/progression'},
        {label: 'Results', url: '/users/' + this.id + '/results'}
      ]
    };
  },
  methods: {
    loadUser () {
      this.axios.get('/users/' + this.id).then(rsp => {
        rsp.data.loaded = true;
        this.student = rsp.data.data;
      }).catch(err => this.$snotify.error(err.response.data.message, 'User Error'));
    },
    loadUserResults () {
      this.axios.get('/user_courses?student_id=' + this.id).then((rsp) => {
        let studentCourses = rsp.data.data;
        let enabledCourseData = studentCourses.map(userCourse => {
          userCourse.modulesTotal = userCourse.user_modules.length;
          userCourse.modulesPassed = 0;
          userCourse.sectionsTotal = 0;
          userCourse.sectionsPassed = 0;
          for (const userModule of userCourse.user_modules) {
            if (userModule.is_complete || userCourse.is_completed)
              userCourse.modulesPassed++;
            userCourse.sectionsTotal = userCourse.sectionsTotal + userModule.user_sections.length;
            for (const userSection of userModule.user_sections) {
              if (userSection.is_complete || userModule.is_complete || userCourse.is_completed)
                userCourse.sectionsPassed++;
            }
          }
          userCourse.modulesPassedPct = Math.round(userCourse.modulesPassed / userCourse.modulesTotal * 100);
          userCourse.sectionsPassedPct = Math.round(userCourse.sectionsPassed / userCourse.sectionsTotal * 100);
          return userCourse;
        });

        this.studentCourses = studentCourses;
        this.enabledCourseData = enabledCourseData;
      }).catch(err => this.$snotify.error(err.response.data.message, 'User Error'));
    }
  },
  mounted () {
    this.loadUser();
    this.loadUserResults();
  },
  metaInfo: {
    title: 'User Progressions'
  },
  props: ['id']
};
</script>
